import React from 'react'
import BottomBar from '../../layouts/bottomBar/BottomBar'
import Navbar from '../../layouts/navbar/Navbar'
import NavbarMobile from '../../layouts/navabrMobile/NavbarMobile'
import MobileLeaderboard from '../../mobileView/leaderboard/MobileLeaderboard'

import '../../components/leaderboard/leaderboard.css';

const MobLeaderboard = () => {
  return (
    <div className='overall'>
        <NavbarMobile />
        <MobileLeaderboard />
        <BottomBar />
    </div>
  )
}

export default MobLeaderboard